import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import styled from "styled-components";
import { pure } from "recompose";

const tooltip = submission_date => (
  <Tooltip id="tooltip">Last submission: {submission_date}</Tooltip>
);

const Button = styled.button`
  display: inline-block;
  height: 24px;
  text-align: center;
  color: #fff;
  background-color: ${({ submitted }) =>
    submitted ? "#52c5cd" : "rgba(255, 0, 0, 0.5)"};
  border-radius: 5px;
  margin-right: 15px;
  text-transform: uppercase;
`;

const SubmitDecisionsButton = pure(props => {
  const {
    id,
    tooltipPlacement,
    data,
    isLoading,
    isActive,
    financial_decisions,
    unaccepted_decisions,
    onClick,
    buttonComponent,
    isPreChecked,
    isRoundEnded
  } = props;
  const tooltip_content = tooltip(data.date);
  const submittedLabel = (
    <fragment>
      <span className="fa fa-check" />
      <span>Posted</span>
    </fragment>
  );
  const loadingLabel = (
    <fragment>
      <span className="fa fa-spinner fa-spin" />
      <span>Posting</span>
    </fragment>
  );
  let status = "";
  let label = "Post Decision";

  if (isLoading) {
    status = '';
    label = loadingLabel;
  } else if (!isPreChecked) {
    status = '';
    label = 'Post Decision';
  } else if (typeof data.success !== 'undefined') {
    status = data.success === true ? 'posted' : '';

    if (status === 'posted') {
      label = submittedLabel;
    }
  } else if (unaccepted_decisions && unaccepted_decisions.FI !== 0) {
    status = "";
    label = "Post Decision";
  } else if (isRoundEnded && financial_decisions && financial_decisions.team) {
    // Closed-round only: rely on ending_cash to resolve Posted state.
    // For active rounds, skip this branch and fall through so the
    // fallback (data.unaccepted) drives the decision instead.
    status = financial_decisions.team.ending_cash >= 0
      ? "posted"
      : "";
    label = financial_decisions.team.ending_cash >= 0
      ? submittedLabel
      : "Post Decision";
  } else {
    status = data.unaccepted === 0 ? "posted" : "";

    if (status === "posted") {
      label = submittedLabel;
    }
  }

  let isDisabled = isLoading;
  if (isActive === false) {
    isDisabled = true;
  }

  const ButtonComponent = buttonComponent ? buttonComponent : Button;

  return (
    <OverlayTrigger placement={tooltipPlacement} overlay={tooltip_content}>
      <ButtonComponent
        id={id}
        submitted={status === "posted"}
        onClick={onClick}
        disabled={isDisabled}
      >
        {label}
      </ButtonComponent>
    </OverlayTrigger>
  );
});

export default SubmitDecisionsButton;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/buttons/submit-decisions.js